<template>
  <FixedAspect :ratio="0.45" class="md:block hidden">
    <CldnVideo :src="videoSrc" :width="1440" sizes="100vw" :autoplay="true" :muted="true" role="presentation" />
  </FixedAspect>
  <FixedAspect :ratio="1.35" class="md:hidden block">
    <CldnVideo :src="videoSrc" :width="425" :ratio="1.35" :autoplay="true" :muted="true" role="presentation" />
  </FixedAspect>
</template>

<script setup>
import FixedAspect from '@/components/common/FixedAspect';
import CldnVideo from '@/components/CldnVideo';

defineProps({
  videoSrc: {
    type: String,
    required: true,
  },
});
</script>
